import { render, staticRenderFns } from "./AppUserDetail.vue?vue&type=template&id=1b7048ac"
import script from "./AppUserDetail.vue?vue&type=script&lang=js"
export * from "./AppUserDetail.vue?vue&type=script&lang=js"
import style0 from "./AppUserDetail.vue?vue&type=style&index=0&id=1b7048ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports